import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Package, ShoppingBag } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';
import { AdminOrders } from '../components/admin/AdminOrders';
import { AdminProducts } from '../components/admin/AdminProducts';

export default function AdminPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('orders');

  useEffect(() => {
    if (user === null) navigate('/login', { replace: true });
    else if (user && user.role !== 'admin') navigate('/account', { replace: true });
  }, [user, navigate]);

  if (!user || user.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const tabClass = (t) =>
    `flex items-center gap-2 px-5 py-2.5 rounded-lg font-medium text-sm transition-all ${
      tab === t ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'
    }`;

  return (
    <>
      <Helmet>
        <title>Admin Dashboard | Harpalyk</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Header />
      <main className="pt-20 min-h-screen bg-gray-50" data-testid="admin-page">
        <div className="max-w-6xl mx-auto px-6 py-12">
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Admin Dashboard</h1>
          <p className="text-gray-500 text-sm mb-8">Manage orders and products — changes go live instantly.</p>

          <div className="flex gap-3 mb-6">
            <button onClick={() => setTab('orders')} data-testid="admin-tab-orders" className={tabClass('orders')}>
              <ShoppingBag className="w-4 h-4" /> Orders
            </button>
            <button onClick={() => setTab('products')} data-testid="admin-tab-products" className={tabClass('products')}>
              <Package className="w-4 h-4" /> Products
            </button>
          </div>

          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
            {tab === 'orders' ? <AdminOrders /> : <AdminProducts />}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
